import { makeStyles, createStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
      minHeight: 480,
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: '#fff',
    },
    sidebar: {
      width: 240,
      flexShrink: 0,
      borderRight: `1px solid ${theme.palette.divider}`,
      backgroundColor: '#f5f5f5',
      alignSelf: 'stretch',
    },
    parentButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      textAlign: 'left',
      padding: theme.spacing(1.5, 2),
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      fontSize: 13,
      fontWeight: 600,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: '#ebebeb',
      },
    },
    parentButtonActive: {
      color: theme.palette.text.primary,
    },
    parentChevron: {
      fontSize: 20,
      transition: 'transform 0.15s ease',
    },
    parentChevronExpanded: {
      transform: 'rotate(180deg)',
    },
    sectionList: {
      paddingBottom: theme.spacing(0.5),
    },
    sectionButton: {
      display: 'block',
      width: '100%',
      textAlign: 'left',
      padding: theme.spacing(1.25, 2, 1.25, 3),
      border: 'none',
      borderLeft: '3px solid transparent',
      background: 'transparent',
      cursor: 'pointer',
      fontSize: 14,
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: '#ebebeb',
      },
    },
    sectionButtonActive: {
      backgroundColor: '#fff',
      borderLeftColor: theme.palette.primary.main,
      fontWeight: 600,
    },
    content: {
      flex: 1,
      padding: theme.spacing(3),
      minWidth: 0,
    },
    contentHeader: {
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(1.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    panel: {
      marginBottom: theme.spacing(1),
      boxShadow: 'none',
      border: `1px solid ${theme.palette.divider}`,
      '&:before': {
        display: 'none',
      },
    },
    panelSummary: {
      backgroundColor: '#f8f8f8',
      minHeight: 48,
      '&.Mui-expanded': {
        minHeight: 48,
        borderBottom: `1px solid ${theme.palette.divider}`,
      },
    },
    panelTitle: {
      fontWeight: 600,
      fontSize: 14,
    },
    panelDetails: {
      padding: 0,
      flexDirection: 'column',
    },
    fieldRow: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: theme.spacing(2, 2.5),
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    fieldLabel: {
      width: 220,
      flexShrink: 0,
      paddingRight: theme.spacing(2),
      paddingTop: 6,
      fontWeight: 500,
      fontSize: 14,
    },
    requiredMark: {
      color: '#d32f2f',
      fontWeight: 700,
      marginLeft: 4,
      fontSize: 18,
      lineHeight: 1,
    },
    requiredPicker: {
      '& .MuiFormLabel-asterisk': {
        color: '#d32f2f',
        fontWeight: 700,
      },
    },
    fieldControl: {
      flex: 1,
      minWidth: 0,
    },
    readonlyValue: {
      paddingTop: 8,
      paddingBottom: 4,
      fontSize: 14,
      fontFamily: 'monospace',
      color: theme.palette.text.primary,
    },
    fieldComment: {
      display: 'block',
      marginTop: theme.spacing(0.75),
      color: theme.palette.text.secondary,
      fontSize: 12,
      lineHeight: 1.4,
    },
    groupDescription: {
      padding: theme.spacing(1.5, 2.5),
      backgroundColor: '#fafafa',
      borderBottom: `1px solid ${theme.palette.divider}`,
      color: theme.palette.text.secondary,
      fontSize: 13,
      whiteSpace: 'pre-line',
    },
    footer: {
      marginTop: theme.spacing(3),
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${theme.palette.divider}`,
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    messageError: {
      marginLeft: theme.spacing(2),
      color: theme.palette.error.main,
    },
    messageSuccess: {
      marginLeft: theme.spacing(2),
      color: '#2e7d32',
    },
  })
)

export type ConfigurationsClasses = ReturnType<typeof useStyles>
